import { Command, HttpMethod } from "~/extensions/api";
import { encryptData } from "~/extensions/utils/EncryptData";
import { commonStore } from "~/store/CommonStore";
export class UpdateAccountCommand extends Command {
    constructor() {
        super(HttpMethod.Post, "account/admin/update");
    }
    static async Create(model) {
        let command = new UpdateAccountCommand();
        command.userCd = model.userCd;
        command.loginId = model.loginId;
        command.password = await encryptData(commonStore.publicKey, model.password);
        command.email = model.email;
        command.tel = model.tel;
        return command;
    }
    /** 契約者コード */
    userCd = null;
    /** ログインID */
    loginId = "";
    /** パスワード */
    password = "";
    /** メールアドレス */
    email = "";
    /** 携帯電話番号 */
    tel = "";
}
